import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import TableCourses from 'modules/pages/lcms/courses/TableCourses';
import React from 'react';

const CoursePage = () => {
  const { appName } = useAppName();

  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title={PAGES[appName]?.lcmsCourse?.title || ''}
          description={PAGES[appName]?.lcmsCourse?.description || ''}
        />
        <TableCourses />
      </Stack>
    </Container>
  );
};

export default CoursePage;
